export const defaultReshopCartText = 'Fast Refunds when you return with';
export const defaultReshopPdpText = 'Free Shipping, Free Returns, and Fast Refunds when you return with';
